module.exports = __webpack_public_path__ + "static/media/market.9453d726.svg";